import React from "react"

import { Checkbox, Input } from "components"
import { productUnitsSymbol } from "constant"
import classes from "./StrrtrmTableRow.module.scss"

const StrrtrmTableRow = (props) => {
  const { acceptedItem, setAcceptedItems } = props

  const handleCheck = (checked) => {
    if (checked) {
      setAcceptedItems(prev =>
        prev.map(ai =>
          ai.optionId === acceptedItem.optionId
            ? { ...ai, acceptedQuantity: String(ai.requestedQuantity) }
            : ai
        )
      )

      return
    }

    setAcceptedItems(prev =>
      prev.map(ai =>
        ai.optionId === acceptedItem.optionId
          ? { ...ai, acceptedQuantity: "0" }
          : ai
      )
    )
  }

  const handleChange = (e) => {
    setAcceptedItems(prev =>
      prev.map(ai =>
        ai.optionId === acceptedItem.optionId
          ? { ...ai, acceptedQuantity: e.target.value }
          : ai
      )
    )
  }

  const numberType =
    acceptedItem.unit === "quantity" ? "int" : "float"

  const checked =
    acceptedItem.acceptedQuantity !== "" &&
    acceptedItem.acceptedQuantity !== "0"

  return (
    <tr>
      <td>
        <Checkbox
          checked={checked}
          showNotChecked
          onChange={handleCheck}
        />
      </td>
      <td>
        {acceptedItem.foodName}{" "}
        {acceptedItem.isSimple ? "" : acceptedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {acceptedItem.requestedQuantity}
        {productUnitsSymbol[acceptedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            min={0}
            type="number"
            value={acceptedItem.acceptedQuantity}
            numberType={numberType}
            onChange={handleChange}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[acceptedItem.unit]}
          </span>
        </div>
      </td>
    </tr>
  )
}

export default React.memo(StrrtrmTableRow)